<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry.id)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    :readOnly="readOnly"
    width="80%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
    :isTextButton="isTextButton"
    :textButton="textButton"
    :editIcon="editIcon"
    :readIcon="readIcon"
  >
  <!-- :editTitle="editTitle" -->
    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry"
        :extraData="extraData"
        id="printableELement"
        :readOnly="readOnly"
        @installment-update="loadServerEntry(entry.id)"
        :isEdit="isEdit"
        :modelNameSingular="modelNameSingular"
      />
    </template>
    <!-- <template slot="action1">
      <BasePrint
        printableElementId="printableELement"
        printButtonLabel="Imprimir Prévia da Venda"
        printTitle="Prévia das Informações da Venda"
        @start-printing="pageLoading = true"
        @stop-printing="pageLoading = false"
      />
    </template> -->
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseEdit from "@shared_components/base_edit.vue";
import BasePrint from "@shared_components/base_print.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      editableEntry: null,
      formErrors: [],
      extraData: null
    };
  },
  props: {
    entry: Object,
    // editTitle: {
    //   type: String,
    //   default: "Edição de Venda"
    // },
    // readTitle: {
    //   type: String,
    //   default: "Visualização de Venda"
    // },
    editIcon: {
      type: String,
      default: "mdi-pencil"
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    isTextButton: {
      type: Boolean,
      default: false
    },
    textButton: {
      type: String,
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    readIcon: {
      type: String,
      default: "mdi-eye"
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit,
    BasePrint: BasePrint
  },
  created() {
    // console.log("edit sale created");
  },
  methods: {
    loadServerEntry: function(id) {
      this.editableEntry = null;
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_SALE_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            id: id
          }
        })
        .then(response => {
          this.editableEntry = response.data.accountContext.sale;
          console.log("load", this.editableEntry);
          this.extraData = response.data;

           this.extraData.customerId = this.editableEntry.customerId;
           this.extraData.paymentConditionRuleId = this.editableEntry.paymentConditionRuleId;
          console.log("sale extra", this.extraData);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    updateServerEntry: function(sale) {
      console.log("sale", sale);
      // console.log("SALE", sale, sale.validations, this.deepFilterEntryWithAllowedFieldsForMutation(sale, sale.validations));
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: UPDATE_SALE_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(sale, sale.validations)
          }
        })
        .then(response => {
          var errors = response.data.updateSale.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseEdit.closeDialog();
            this.$emit("entry-updated");
            this.resetForm();
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.pageLoading = false));
    },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.updateServerEntry(this.editableEntry)
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
      this.$emit("entry-canceled");
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};
const LOAD_SALE_QUERY = gql `
  query ($id: ID!) {
    accountContext {
      sale(id: $id) {
        id
        cfopId
        code
        billDate
        date
        fiscalDocumentType
        estimatedDeliveryDate
        orderValidity
        customerId
        totalPrice
        validations
        paymentConditionRuleId
        volume
        netWeight
        grossWeight
        specie
        brand
        observation
        carrierId
        carrier {
          id
          name
        }
        carriageModalityId
        carriageModality {
          id
          text
        }
        carrierPatrimonyId
        carrierPatrimony {
          id
          description
        }
        carrierAddressId
        carrierAddress{
          id
          fullAddressWithCityState
        }
        trailerId
        trailer{
          id
          description
        }
        carrierLicensePlate
        carrierLicensePlateStateId
        totalCarriageValue
        totalDiscountValue
        totalInsuranceValue
        otherExpensesTotalValue
        dummyExitMovementItemsAttributes {
          id
          price
          quantity
          lossQuantity
          lossPercentage
          itemWeight{
            liquidWeight
            grossWeight
          }
          isPerformance
          packagingQuantity
          packagingUnitName
          packagingPrice
          discount
          totalDiscount
          liquidPrice
          itemId
          storageId
          unitPrice
          dummyExitMovementItemLotsAttributes{
            id
            manufacturingLotId
            quantity
            packagingQuantity
            isNewLot
            name
            lotNumber
            dueDate
            manufacturingDate
          }
          item {
            id
            name
            typeText
            description
            unit {
              name
            }
            packagings {
              id
              name
              basicUnitName
              size
              text              
            }
          }
          storage {
            id
            name
          }
          packagingId
          packaging {
            id
            name
            basicUnitName
            size
            text
          }
        }
        paymentsAttributes {
          id
          code
          value
          initialDate
          installmentsIntervalId
          installmentsInterval {
            id
            description
            intervalInDays
          }
          paymentConditionId
          paymentCondition {
            id
            description
            numberOfInstallments
          }
          paymentMethodId
          paymentMethod {
            id
            name
          }
          bankAccountId
          bankAccount {
            id
            name
          }
          installmentsAttributes {
            id
            value
            originalValue
            customCode
            dueDate
            code
            status
            statusKey
            statusColor
            paidAmount
            totalPaidAmount
            paymentDate
            bankAccount {
              id
              name
            }
          }
        }
      }
      allPaymentConditionRules{
        id
        name
      }
      allCustomers {
        id
        name
      }
      accountPermissions{
        isAltavenda
      }
      allCarriers {
        id
        name
      }
      allCfops{
        id
        text
      }
    }
    globalContext {
			allPaymentConditions {
        id
        description
        numberOfInstallments
      }
      allCarriageModalities {
        id
        text
      }
      allStates {
        id
        shortName
      }
    }
  }
`;

const UPDATE_SALE_MUTATION = gql `
  mutation($input: SaleUpdateInputObject!) {
    updateSale(input: $input) {
      cashFlow {
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>